import React,{ useState } from 'react'
import MainComponent from './components/MainComponent/MainComponent';
import GlobalLangCtx from './components/ContexGlobal/LangContex'
import FileNotFound from './components/404/404';
// import RedirectComp from './components/RedirectComp/RedirectComp'

import {
    useRoutes
  } from 'react-router-dom';

  
const App = () =>{
    const [globalLan, setGlobalLan] = useState("uk")
    return (
        <GlobalLangCtx.Provider value={[globalLan, setGlobalLan]}>
            <MainComponent/>
        </GlobalLangCtx.Provider>
    )
}

// creare un componente per la redirezione ai progetti interni di web_app in PHP
// {path: '*', element: <FileNotFound />},     
// {path: '/web_app/projects/php/pizza/index.html', element: false},

function WrapApp() {
  let element = useRoutes([
    {path: '/', element: <App />},
    {path: '*', element: <FileNotFound />}      
    ]);
  
    return element;
}

// per l'esporto multiplo d'elementi non si deve utilizzare 'export default'
// e nel file che importa va destrutturato l'elemento, con: import {GlobalState} from '../../App'
export {App}; // dopo riabilita i react-router
// export {WrapApp};
export {GlobalLangCtx};